<template>
  <div class="flex flex-wrap gap-4">
    <div>
      <NNumberField
        :default-value="144"
        size="xs"
      />
    </div>

    <div>
      <NNumberField
        :default-value="144"
        size="sm"
      />
    </div>

    <div>
      <NNumberField
        :default-value="144"
        size="md"
      />
    </div>

    <div>
      <NNumberField
        :default-value="144"
        size="xl"
      />
    </div>

    <div>
      <NNumberField
        :default-value="144"
        size="3xl"
      />
    </div>
  </div>
</template>
